import { render, staticRenderFns } from "./PrfEarningCertification.vue?vue&type=template&id=aafbe07e"
import script from "./PrfEarningCertification.vue?vue&type=script&lang=js"
export * from "./PrfEarningCertification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports